import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { registerSW } from 'virtual:pwa-register'

// Clear old caches that might exist from before SW was implemented
const clearOldCaches = async () => {
  if ('caches' in window) {
    const cacheNames = await caches.keys()
    // Delete any caches that don't match our versioned naming pattern
    const oldCaches = cacheNames.filter(name => !name.includes('-v'))
    await Promise.all(oldCaches.map(name => caches.delete(name)))
    if (oldCaches.length > 0) {
      console.log('Cleared old caches:', oldCaches)
    }
  }
}

// Clear old caches immediately on load
clearOldCaches()

// Register service worker with auto-update
registerSW({
  immediate: true, // Register immediately
  onNeedRefresh() {
    // When a new version is available, reload to get the latest
    console.log('New version available, updating...')
    window.location.reload()
  },
  onOfflineReady() {
    console.log('App ready to work offline')
  },
  onRegisteredSW(_swUrl: string, registration: ServiceWorkerRegistration | undefined) {
    console.log('Service Worker registered successfully')
    // Check for updates every hour
    if (registration) {
      setInterval(() => {
        console.log('Checking for updates...')
        registration.update()
      }, 60 * 60 * 1000) // 1 hour
    }
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
